import React from "react";

export default function SummaryStyle() {

    return (
        <style type="text/css">{`
                .stock-summary {
                    min-height: 227px;
                }
                
                .stock-summary td:first-child {
                    text-align: right;
                    font-size: 13px;
                    color: #232a31;
                }
                
                .stock-summary td:nth-child(2) {
                    text-align: left;
                    font-weight: 600;
                    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
                    direction: ltr;
                    font-size: 13px;
                    width: 51%
                }
                
                .stock-summary table {
                    border-collapse: collapse;
                    border-spacing: 0;
                    width: 100%;
                }
                
                .stock-summary td {
                    height: 36px;
                }
                
                .stock-summary tr {
                    border-bottom: 1px solid #e0e4e9;
                }
                
                .stock-summary .last-title {
                    font-family: Roboto-Medium, Helvetica Neue, Arial, sans-serif;
                    direction: ltr;
                    font-size: 24px;
                }
                
                .stock-summary h1 {
                    font-size: 18px;
                    overflow: hidden;
                }
                
                .fav-btn-animation {
                    animation: horizontal 2s ease infinite;
                    -webkit-animation: horizontal 2s ease infinite;
                }
            `}
        </style>
    );
}
